<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-card>
	   			<v-card-title>
            <v-text-field v-model="filter.title" label="Item Name" class="mr-3"></v-text-field>
            <v-text-field v-model="filter.code" label="Item Code" class="mr-3"></v-text-field>
            <search-btn @click="filterData" />
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px" v-if="hasCreateAccess">
              <v-btn slot="activator" round color="primary" dark small class="ml-4">Add New</v-btn>
              <v-form v-model="validForm">
                <v-card>
                  <v-card-title>
                    <span class="headline" v-text="item.id ? 'Update Item' : 'Add Item'"></span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md py-0>
                      <v-layout wrap>
                        <v-flex xs12 sm6>
                          <v-switch v-model="item.is_parent" label="Is Parent Item?" v-on:change="removeParent"></v-switch>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="!item.is_parent">
                          <v-autocomplete v-model="item.parent_id" :items="parentItems" item-text="item_code" item-value="id" label="Parent Code" :search-input.sync="parentItemSearch" :loading="parentItemLoading" hide-no-data v-on:change="parentItemOnChange" clearable>
                            <template slot="item" slot-scope="data">
                              <v-list-tile-content>
                                <v-list-tile-title v-text="data.item.item_code"></v-list-tile-title>
                                <v-list-tile-sub-title class="caption" v-text="data.item.title"></v-list-tile-sub-title>
                              </v-list-tile-content>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field :rules="codeRules" counter="20" v-model="item.item_code" label="Item Code"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field :rules="nameRules" counter="50" v-model="item.title" label="Item Name"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-autocomplete :rules="requireRule" v-model="item.category" :items="itemCategories" item-text="title" item-value="id" label="Category" :readonly="hasParent"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="!item.is_parent">
                          <v-autocomplete :rules="requireRule" v-model="item.brand" :items="brands" item-text="title" item-value="id" label="Brand"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-autocomplete :rules="requireRule" v-model="item.unit" :items="units" item-text="title" item-value="id" label="Unit" :readonly="hasParent"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-autocomplete :rules="requireRule" v-model="item.tax" :items="taxes" item-text="title" item-value="id" label="Tax" :readonly="hasParent"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="!item.is_parent">
                          <v-text-field :rules="rateRules" counter="7" maxlength="7" v-model="item.rate" label="Rate"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <td>{{ props.item.title }}</td>
              <td>{{ props.item.item_code }}</td>
              <td>{{ props.item.category_name }}</td>
              <td>{{ props.item.brand_name }}</td>
              <td>{{ props.item.unit_name }}</td>
              <td>{{ props.item.tax_name }}</td>
				      <td>{{ props.item.rate }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn :item="props.item" />
                <delete-btn :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(items)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'Items',
    data () {
      return {
        model: 'item',
      	title: "Items",
        validForm: false,
      	processing: false,
        dialog: false,
        deleteDialog: false,
      	items: [],
        filter: {
          title: "",
          code: ""
        },
        headers: [
          { text: 'Item Name', value: 'title'},
          { text: 'Item Code', value: 'item_code'},
          { text: 'Category', value: 'category_name'},
          { text: 'Brand', value: 'brand_name'},
          { text: 'Unit', value: 'unit_name'},
          { text: 'Tax', value: 'tax_name'},
          { text: 'Rate', value: 'rate'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        defaultItem: {
          id: "",
          title: "",
          item_code: "",
          category: "",
          brand: null,
          unit: "",
          tax: "",
          rate: 0,
          is_deleted: false,
          is_parent: false,
          parent_id: null
        },
        nameRules: [
            v => !!v || 'Name is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        requireRule: [
          v => !!v || 'Field is required'
        ],
        codeRules: [
            v => !!v || 'Item code is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 20 || 'Maximum 20 characters allowed'
        ],
        rateRules: [
            v => !!v || 'Rate is required',
            v => /^-?\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Rate must be valid'
        ],
        parentItems: [],
        parentItemSearch: "",
        parentItemLoading: false
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Items',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Items')
    },
    methods: {

      loadPage () {
        
        let api_path = `${this.config.apis.getItems}?page=${this.currentPage}&per_page=${this.paginationOptions.rowsPerPage}`
        
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          if (val) {
            filterArray.push(`${key}=${val}`)
          }
        }

        if (filterArray.length) {
          api_path += '&' + filterArray.join('&')
        }

        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      getParentItems (name, val) {

        let api_path = `${this.config.apis.getItems}?page=${this.currentPage}&per_page=${this.paginationOptions.rowsPerPage}&is_parent=1&${name}=${val}`

        this.parentItemLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.parentItemLoading = false
            if (this.isSuccessResponse(response)) {
              this.parentItems = response.data.data.items

              if (this.dialog && this.item.id && this.item.parent_id) {
                this.parentItemOnChange(this.item.parent_id)
              }
            }
        })
        .catch((error) => {
            this.parentItemLoading = false
        })
      },

      removeParent () {
        if (this.item.is_parent) {
          this.item.parent_id = null
          this.parentItemSearch = ""
        }
      },

      parentItemOnChange (val) {
        
        let item = this.parentItems.filter(function(item){
          return item.id == val
        })

        if (item.length) {
          item = item[0]
          this.item.unit = item.unit
          this.item.category = item.category
          this.item.tax = item.tax
        }

      },

      addItem () {
        this.processing = true
        this.axios.post(this.config.apis.addItem, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let new_item = Object.assign({}, this.item)
              new_item.id = response.data.data.id

              let category = this.itemCategories.filter( item => {
                return item.id == new_item.category
              })

              new_item.category_name = category ? category[0].title : ""

              let unit = this.units.filter( item => {
                return item.id == new_item.unit
              })

              new_item.unit_name = unit ? unit[0].title : ""

              let tax = this.taxes.filter( item => {
                return item.id == new_item.tax
              })

              new_item.tax_name = tax ? tax[0].title : ""

              if (new_item.brand) {
                let brand = this.brands.filter( item => {
                  return item.id == new_item.brand
                })

                new_item.brand_name = brand ? brand[0].title : ""
              }

              this.items.unshift(new_item)

              this.notifySuccess('insertSuccess')
              this.close()
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },
      updateItem () {
      	this.processing = true
        this.axios.put(this.config.apis.updateItem.replace(":id", this.item.id), this.item)
          .then((response) => {

            if (this.isSuccessResponse(response)) {

              let category = this.itemCategories.filter( item => {
                return item.id == this.item.category
              })

              this.item.category_name = category ? category[0].title : ""

              let unit = this.units.filter( item => {
                return item.id == this.item.unit
              })

              this.item.unit_name = unit ? unit[0].title : ""

              let tax = this.taxes.filter( item => {
                return item.id == this.item.tax
              })

              this.item.tax_name = tax ? tax[0].title : ""

              if (this.item.brand) {
	              let brand = this.brands.filter( item => {
	                return item.id == this.item.brand
	              })

	              this.item.brand_name = brand ? brand[0].title : ""
          	  }

              this.notifySuccess('updateSuccess')
              this.close()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.close()
          })
      },

      editItem (item) {
        this.item = item
        this.dialog = true
        if (this.item.parent_id) {
          this.getParentItems('id', this.item.parent_id)
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      }

    },
    mounted () {
      this.getItemCategories()
      this.getUnits()
      this.getTaxes()
      this.getBrands()
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {
      hasParent () {
        return !!this.item.parent_id
      }
    },

    watch: {

      parentItemSearch (val) {
        let current = this.parentItems.filter(item => item.id === this.item.parent_id)
        let exist = current.length && current[0].item_code === val
        if (val && !exist) {
          this.getParentItems('code', this.parentItemSearch)
        }
      },

    }

  }
</script>
